import React from 'react';
import './ui.css';

/**
 * An on/off setting.
 *
 * Replaces a checkbox where the thing being set is a state rather than an
 * item being selected from a list — "count towards the club ladder", "paid",
 * "registration open". A checkbox reads as one of several; a switch reads as
 * something you are turning on.
 *
 * role="switch" is a button, not an input, so it carries its own accessible
 * name: either the visible `label` or, when the switch sits in a table cell
 * with the name in another column, an `ariaLabel`. One of the two is always
 * needed — a switch announced as just "on" tells you nothing.
 */
function Toggle({ ariaLabel, checked = false, disabled = false, label, onChange, style }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label ? undefined : ariaLabel}
      className="gs-toggle"
      disabled={disabled}
      style={style}
      onClick={() => onChange && onChange(!checked)}>
      <span className="gs-toggle-track">
        <span className="gs-toggle-knob" />
      </span>
      {label && <span className="gs-toggle-label">{label}</span>}
    </button>
  );
}

export default Toggle;
